import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAnalytics } from './state/AnalyticsProvider';

export function AnalyticsRouteListener({
  pageName,
  routeParams,
}: {
  pageName: string;
  routeParams?: Record<string, string | undefined>;
}) {
  const analytics = useAnalytics();
  const paramsFromRoute = useParams<Record<string, string | undefined>>();
  const { pathname } = useLocation();

  // `useParams` returns a new object on every render of the enclosing Route, so the
  // params have to be compared by value. Keying the effect on the object identity
  // re-runs it on every re-render, and each run counts as a page view in Google Analytics.
  const routeParamsKey = JSON.stringify(
    routeParams && Object.keys(routeParams).length > 0 ? routeParams : paramsFromRoute
  );

  useEffect(() => {
    if (pageName) {
      const resolvedRouteParams: Record<string, string | undefined> = JSON.parse(routeParamsKey);

      // TODO: the calling page should use analytics.updatePage to pass this data
      const brandCode = resolvedRouteParams.crmBrandCode || resolvedRouteParams.brandCode;
      const ageCategory = resolvedRouteParams.crmAgeCategory;
      const properties: Record<string, unknown> = { brandCode, ageCategory };

      if (pageName.indexOf('BibleStudySessionTimeline') === 0) {
        properties.isCustomizedTimeline = !!resolvedRouteParams.timelineCustomizationId;
      }

      analytics.viewPage(pageName, properties);
    }
  }, [pageName, pathname, routeParamsKey, analytics]);

  return null;
}
